export const SUPER_ADMIN = "Super Admin";
export const ADMIN = "Admin";
export const USER = "User";